export class SidebarState {
  public isOpen: boolean = false;

  constructor() {}

  show() {
    let body: HTMLBodyElement = document.querySelector('body');

    body.classList.add('overflow-hidden');
    this.isOpen = true;
  }

  hide() {
    let body: HTMLBodyElement = document.querySelector('body');

    body.classList.remove('overflow-hidden');
    this.isOpen = false;
  }
}
